import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CreatePairingKeyMutationVariables } from '@uigy/generated/graphql';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { NotificationComponent } from '@uigy/shared/components/info/notification.component';
import { GenericSliderPage } from '@uigy/shared/components/slider-v2/models/generic-slider-page';
import { ToasterType } from '@uigy/shared/components/toaster/enums/toaster-type.enum';
import { ValidationMessageComponent } from '@uigy/shared/components/validation-message/validation-message.component';
import { hostnameValidator } from '@uigy/shared/form-validators/hostname.validator';
import { MaterialModule } from '@uigy/shared/material-module/material.module';
import { DateTimeService } from '@uigy/shared/services/date-time/date-time.service';
import { FormValidatorsService } from '@uigy/shared/services/form-validators.service';
import { LanguageService } from '@uigy/shared/services/language.service';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  imports: [
    MaterialModule,
    I18NextModule,
    NotificationComponent,
    ValidationMessageComponent,
    ReactiveFormsModule,

  ],
  selector: 'app-api-key-set-details-slider',
  templateUrl: './api-key-set-details-slider.component.html',
  styleUrl: './api-key-set-details-slider.component.scss'
})
export class ApiKeySetDetailsSliderComponent implements GenericSliderPage<CreatePairingKeyMutationVariables> {
  private languageService = inject(LanguageService);
  protected formValidatorsService = inject(FormValidatorsService);
  protected dateTimeService = inject(DateTimeService);
  protected readonly toasterType = ToasterType;

  public readonly errorTexts = this.languageService.errorTexts;
  public readonly otAgentsTexts = this.languageService.texts.ot_agents;
  public readonly IconsEnum = IconsEnum;
  public isLoaded = false;

  public form: FormGroup = new FormGroup({
    description: new FormControl('', [Validators.required]),
    icpAddress: new FormControl('', [Validators.required, hostnameValidator]),
    expiryTime: new FormControl(90, [Validators.required, Validators.pattern(/^\d+$/), Validators.min(1), Validators.max(365)]),
  });

  constructor() {
  }

  public getData(): CreatePairingKeyMutationVariables {
    return {
      description: this.description.value,
      expiryTime: this.dateTimeService.now().add(this.expiryTime.value, 'd').toISOString(),
      icpAddress: this.icpAddress.value,
    };
  }

  public initData(data: CreatePairingKeyMutationVariables): void {
    this.form.patchValue({
      icpAddress: data.icpAddress,
      description: data.description || '',
    });
  }

  public isValid(): boolean {
    return this.form.valid;
  }

  public get description(): FormControl {
    return this.form.get('description') as FormControl;
  }

  public get expiryTime(): FormControl {
    return this.form.get('expiryTime') as FormControl;
  }

  public get icpAddress(): FormControl {
    return this.form.get('icpAddress') as FormControl;
  }
}
